<script lang="ts">
  import { default as InvoicesIndex } from "@retailer/svelte/Payments/Index.svelte";

</script>

<InvoicesIndex selectedTab={"payment-settings"} />
